var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.97499C5.86667 6.97499 5.73734 6.94999 5.612 6.89999C5.48667 6.84999 5.38267 6.78332 5.3 6.69999L0.700003 2.09999C0.516669 1.91665 0.425003 1.68332 0.425003 1.39999C0.425003 1.11665 0.516669 0.883321 0.700003 0.699987C0.883336 0.516654 1.11667 0.424988 1.4 0.424988C1.68334 0.424988 1.91667 0.516654 2.1 0.699987L6 4.59999L9.9 0.699987C10.0833 0.516654 10.3167 0.424988 10.6 0.424988C10.8833 0.424988 11.1167 0.516654 11.3 0.699987C11.4833 0.883321 11.575 1.11665 11.575 1.39999C11.575 1.68332 11.4833 1.91665 11.3 2.09999L6.7 6.69999C6.6 6.79999 6.49167 6.87099 6.375 6.91299C6.25834 6.95499 6.13334 6.97565 6 6.97499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowBlack);
export default __webpack_public_path__ + "static/media/downArrowBlack.2202fc3aca78902b5864dbb1140d6b78.svg";
export { ForwardRef as ReactComponent };